document.addEventListener("teeinblue-event-component-injected", function () {
  moveElementAfter('.uploadkit', '#teeFormInputs');
});

const moveElementAfter = (target, after) => {
  const targetEl = document.querySelector(target);
  const afterEl = document.querySelector(after);
  if (targetEl && afterEl) {
    afterEl.after(targetEl);
  }
};

document.addEventListener('teeinblue-event-after-cart-added', function() {
  $.ajax({
    type: 'GET', 
    url: '/',
    dataType: 'html',
    success: function(cart_html) {
      var cartdrawer_content = $(cart_html).find('#my-sidebar-cart').html();
      $('#my-sidebar-cart').html(cartdrawer_content);

      reslider();

      var cart_count = $(cart_html).find('#header-cart .header-cart__count').html();
      if(cart_count > 1 ){
        $('.cart-msg').text('Spare weitere 10€ auf jedes zusätzliche Produkt ✨');
      }else{
        $('.cart-msg').text('10€ Rabatt ab dem 2. Produkt + kostenloser Versand 🎉');
      }
      
      $('#header-cart .header-cart__count').html(cart_count);
      $('.cart-drawer').addClass('open_cartdrawer');
      $('body').addClass('js-drawer-open');
      $('.cart-overlay').show();
    }
  });
});